// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"8d3dcded","79":"6a864146","323":"d7474f6a","381":"2679d5a8","531":"c2bf0116","570":"8844e813","899":"536e83d8"}[chunkId] + ".chunk.js";
};